/**
 *
 * Schedule - CVent Block
 *
 * Handling CVent schedule
 */

jQuery(document).ready(function () {
    const $ = jQuery;

    const scheduleBlock = $(".itbl-schedule-2024");

    if(!scheduleBlock.length) {
        return;
    }

    function events() {
        // Add expand functionality
        $('.itbl-schedule-2024-filters__expand').on('click', function () {
            $(this).parent().toggleClass('active');
        });

        $('.itbl-schedule-2024-schedule-timeslot__session-description').each(function () {
            const $description = $(this);

            $description.on('click', function () {
                $(this).toggleClass('expanded');
            });
        });

        // Add category filter functionality
        $('.itbl-schedule-2024__category-select').on('change', function () {
            const $scheduleItems = $(this).parent().parent().find('.itbl-single-schedule');
            const selectedCategory = $(this).val();

            $scheduleItems.each(function () {
                const $scheduleItem = $(this);

                if(selectedCategory === 'all') {
                    $scheduleItem.show();
                } else {
                    if($scheduleItem.hasClass('itbl-single-schedule--category-' + selectedCategory)) {
                        $scheduleItem.show();
                    } else {
                        $scheduleItem.hide();
                    }
                }
            });
        });

        // Add filter functionality
        $('.itbl-schedule-2024-filters__filter-tag').on('click', function () {
            const $filterTag = $(this);
            const filter = $filterTag.data('filter');
            const $filterTagParent = $filterTag.parent();
            const isActive = $filterTag.hasClass('active');
            const $timeSlots = $('.itbl-schedule-2024-schedule-timeslot');
            const $filtersWrapper = $('.itbl-schedule-2024-filters');

            $filterTagParent.find('.itbl-schedule-2024-filters__filter-tag').removeClass('active');
            $('.itbl-schedule-2024-schedule-timeslot__session').addClass('hidden');
            
            if(!isActive) {
                $filterTag.addClass('active');
            }

            let activeFilters = [];

            $('.itbl-schedule-2024-filters__filter-tag.active').each(function () {
                const $activeFilterTag = $(this);
                const activeFilter = $activeFilterTag.data('filter');

                activeFilters.push(activeFilter);
            });

            // show all sessions that match all active filters
            let filtersClasses = '';

            activeFilters.forEach(filter => {
                filtersClasses += '.' + filter;
            });

            $('.itbl-schedule-2024-schedule-timeslot__session' + filtersClasses).removeClass('hidden');

            // if no filters are active, show all
            if($('.itbl-schedule-2024-filters__filter-tag.active').length === 0) {
                $('.itbl-schedule-2024-schedule-timeslot__session').removeClass('hidden');
            }

            // check if all children of timeslots are hidden, if so, hide timeslot
            $timeSlots.each(function () {
                const $timeSlot = $(this);
                const $sessions = $timeSlot.find('.itbl-schedule-2024-schedule-timeslot__session');
                const $hiddenSessions = $timeSlot.find('.itbl-schedule-2024-schedule-timeslot__session.hidden');

                if($sessions.length === $hiddenSessions.length) {
                    $timeSlot.addClass('hidden');
                } else {
                    $timeSlot.removeClass('hidden');
                }
            });

            // check if all children of dateslots are hidden, if so, add 'No sessions' message
            $('.itbl-schedule-2024-schedule-dateslot').each(function () {
                const $dateSlot = $(this);
                const $timeSlots = $dateSlot.find('.itbl-schedule-2024-schedule-timeslot');
                const $hiddenTimeSlots = $dateSlot.find('.itbl-schedule-2024-schedule-timeslot.hidden');

                if($timeSlots.length === $hiddenTimeSlots.length) {
                    $dateSlot.find('.itbl-schedule-2024-schedule-dateslot__no-sessions').addClass('active');
                } else {
                    $dateSlot.find('.itbl-schedule-2024-schedule-dateslot__no-sessions').removeClass('active');
                }
            });
        });

        // Clear all filters
        $('.itbl-schedule-2024-filters__button').on('click', function () {
            $('.itbl-schedule-2024-schedule-timeslot__session.hidden').removeClass('hidden');
            $('.itbl-schedule-2024-schedule-timeslot.hidden').removeClass('hidden');
            $('.itbl-schedule-2024-schedule-dateslot__no-sessions').removeClass('active');
            $('.itbl-schedule-2024-filters__filter-tag').removeClass('active');
            $('.itbl-schedule-2024-filters__expand').parent().removeClass('active');
        });

        // Add day switch functionality
        $('.itbl-schedule-2024-dates__date').on('click', function () {
            const $date = $(this);
            const date = $date.data('date');

            $('.itbl-schedule-2024-dates__date').removeClass('active');
            $date.addClass('active');

            $('.itbl-schedule-2024-schedule-dateslot').removeClass('active');
            $('.itbl-schedule-2024-schedule-dateslot[data-date="' + date + '"]').addClass('active');
        });
    };

    events();
});